<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field
        :disabled="disabled"
        :value="date"
        :label="label"
        prepend-icon="mdi-calendar"
        readonly
        v-on="on"
        ></v-text-field>
    </template>
    <v-date-picker :value="date" @input="datePick"
      :min="minDate" :max="maxDate"
      no-title></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'date-pickup',
  data () {
    return {
      menu: false
    }
  },
  props: {
    label: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: true
    },
    minDate: {
      type: String
    },
    maxDate: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    datePick: function (val) {
      this.menu = false
      this.$emit('set-date', val)
    }
  }
}
</script>

<style scoped>
</style>
